import React from "react";
import { Link } from "react-router-dom";
import { LogoMark } from "./Navbar";
import NewsletterForm from "./NewsletterForm";
import { TRADES } from "../lib/content";

export default function Footer() {
  return (
    <footer
      className="bg-[#0B3D5C] text-[#FAF7F2] mt-32"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-6 py-20">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <Link to="/" className="flex items-center gap-2 font-sans-tight font-extrabold text-xl">
              <LogoMark size={24} />
              <span>LeadRiver</span>
            </Link>
            <p className="font-serif-body text-[17px] leading-relaxed text-[#FAF7F2]/85 mt-6 max-w-md">
              LeadRiver does not contact your customers. We never text, call, or
              email anyone on your behalf. We work inside your systems and draft
              what needs sending. You send.
            </p>
            <div className="mt-8">
              <NewsletterForm dark testId="footer" />
            </div>
          </div>

          <div className="md:col-span-3">
            <p className="kicker text-[#E07B3A]">Trades</p>
            <ul className="mt-5 space-y-3 font-sans-tight text-[15px]">
              {TRADES.map((t) => (
                <li key={t.slug}>
                  <Link
                    to={`/trades/${t.slug}`}
                    data-testid={`footer-trade-${t.slug}`}
                    className="text-[#FAF7F2]/80 hover:text-white"
                  >
                    {t.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="kicker text-[#E07B3A]">Product</p>
            <ul className="mt-5 space-y-3 font-sans-tight text-[15px]">
              <li><a href="/#how" className="text-[#FAF7F2]/80 hover:text-white">How it works</a></li>
              <li><a href="/#workflows" className="text-[#FAF7F2]/80 hover:text-white">Workflows</a></li>
              <li><a href="/#pricing" className="text-[#FAF7F2]/80 hover:text-white">Pricing</a></li>
              <li><a href="/#founding" className="text-[#FAF7F2]/80 hover:text-white">Founding program</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="kicker text-[#E07B3A]">Legal</p>
            <ul className="mt-5 space-y-3 font-sans-tight text-[15px]">
              <li><Link to="/legal/privacy" className="text-[#FAF7F2]/80 hover:text-white">Privacy</Link></li>
              <li><Link to="/legal/terms" className="text-[#FAF7F2]/80 hover:text-white">Terms</Link></li>
              <li><Link to="/legal/aup" className="text-[#FAF7F2]/80 hover:text-white">AUP</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/15 flex flex-col md:flex-row justify-between gap-4 text-sm font-sans-tight text-[#FAF7F2]/55">
          <p>© {new Date().getFullYear()} LeadRiver, Inc. An autonomous company.</p>
          <p>Built for the guy who's on a roof when the lead comes in.</p>
        </div>
      </div>
    </footer>
  );
}
